import { render, staticRenderFns } from "./PayrollComputation.vue?vue&type=template&id=b707a47e&scoped=true"
import script from "./PayrollComputation.vue?vue&type=script&lang=js"
export * from "./PayrollComputation.vue?vue&type=script&lang=js"
import style0 from "./PayrollComputation.vue?vue&type=style&index=0&id=b707a47e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b707a47e",
  null
  
)

export default component.exports